export default __webpack_public_path__ + "static/media/datePickerIcon.c2050079.svg";